import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  fetchUserInfo,
  fetchUserInfoExp,
  logout,
} from "../../actions/security";
import { useDispatch, useSelector } from "react-redux";

import ConfirmDialog from "../../components/Reusable/ConfirmDialog";
import ProfileItemLink from "./ProfileItemLink";
import ScalePercentage from "../../components/Reusable/ScalePercentage";
import { fetchReamingPointsList } from "../../actions/points";
import { t } from "i18next"; // Import t function for translation

const MyProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const { pointsReaming } = useSelector((state) => state.pointsReducer);

  const image = loggedUserReducer?.loggedUser?.image
    ? loggedUserReducer?.loggedUser?.image
    : "/images/no-user.png";

  const logoutFunctionHandler = () => {
    setShowModal(true);
  };

  const confirmLogout = () => {
    dispatch(logout(navigate));
  };

  useEffect(() => {
    dispatch(fetchUserInfoExp());
    dispatch(fetchReamingPointsList());
    dispatch(fetchUserInfo());
  }, [dispatch]);

  return (
    <div className="profile-main-container">
      <div className="profile-image-holder">
        <div className="profile-image-content">
          <img
            src={loggedUserReducer?.userInfoList?.image || image}
            className="img-fluid profile-image-profile"
            alt="User"
          />
        </div>
        <div className="profile-user-name">
          {loggedUserReducer?.userInfoList?.name}{" "}
          {loggedUserReducer?.userInfoList?.lastName}
        </div>
        <div className="profile-user-name-sector">
          {loggedUserReducer?.userInfoList?.sector == "DEVICE_FOR_HOUSE"
            ? t("registration.sector_name_1")
            : loggedUserReducer?.userInfoList?.sector == "TV_AUDIO"
            ? t("registration.sector_name_2")
            : t("registration.sector_name_3")}
        </div>
        <div className="user-points-content" style={{ marginTop: "20px" }}>
          <div className="user-points-main-info-header-badge">
            <img
              src={loggedUserReducer?.userInfoExp?.levelBadge}
              className="img-fluid profile-badge-level"
              alt="LG"
            />
            <div className="user-level-name-badge text-center">
              {t(`level.${loggedUserReducer?.userInfoExp?.levelName}`)}
            </div>
          </div>
        </div>
      </div>
      <div className="other-profile-info">
        <div className="other-profile-info-content">
          <div className="other-profile-info-content-items-header">
            <div className="other-profile-info-level other-profile-info-level-first">
              <div className="other-profile-info-points">
                <div className="other-profile-info-points-text">
                  {t("myProfile.pointsText")}:
                </div>
              </div>
              <div className="other-profile-info-level-title">
                {pointsReaming || 0}
              </div>
            </div>
            {loggedUserReducer?.loggedUser?.accountType != "MANAGER" && (
              <div className="other-profile-info-level">
                <div className="other-profile-info-points">
                  <div className="other-profile-info-points-text">
                    XP {t("education.education_list_item.pointsSmall")}:
                  </div>
                </div>
                <div className="other-profile-info-level-title">
                  {loggedUserReducer?.userInfoExp?.experience || 0}
                </div>
              </div>
            )}
          </div>
          {/* {loggedUserReducer?.loggedUser?.accountType != "MANAGER" && (
            <div className="expirence-scale-profile-holder">
              <ScalePercentage />
            </div>
          )} */}
          <div className="other-profile-info-buttons">
            {/* <div className="other-profile-info-buttons-item-holder">
              <div className="other-profile-info-buttons-item">
                {t("myProfile.activityText")}
              </div>
            </div> */}
            <div className="other-profile-info-buttons-item-holder">
              <Link to="/order">
                <div className="other-profile-info-buttons-item">
                  {t("myProfile.saleReportLink")}
                </div>
              </Link>
            </div>
          </div>
          <div className="other-profile-info-links">
            <ProfileItemLink
              title={t("myProfile.userPointsLink")}
              link={"/user-points"}
              image={"/images/icon-material.svg"}
            />
            <ProfileItemLink
              title={t("myProfile.settingsLink")}
              link={"/settings"}
              image={"/images/settings.png"}
            />
            <ProfileItemLink
              title={t("myProfile.informationLink")}
              link={"/informations"}
              image={"/images/information.png"}
            />
            <ProfileItemLink
              title={t("myProfile.logoutText")}
              onClickFunction={logoutFunctionHandler}
              image={"/images/logout.png"}
            />
          </div>
        </div>
      </div>
      <ConfirmDialog
        showModal={showModal}
        setShowModal={setShowModal}
        confirmLogout={confirmLogout}
        modalTitle={t("myProfile.confirmLogoutTitle")}
      />
    </div>
  );
};

export default MyProfile;
